import { render, staticRenderFns } from "./bannerHeader.vue?vue&type=template&id=1286cdec&scoped=true&"
import script from "./bannerHeader.vue?vue&type=script&lang=js&"
export * from "./bannerHeader.vue?vue&type=script&lang=js&"
import style0 from "./bannerHeader.vue?vue&type=style&index=0&id=1286cdec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1286cdec",
  null
  
)

export default component.exports